module.exports = __webpack_public_path__ + "static/media/CARD_BACK_EYE.2ee93926.png";